export const isDevEnv = () => {
  if (typeof process !== 'undefined' && process.env !== undefined) {
    return process.env.NODE_ENV !== 'production'
  }

  // TODO re-enable the full guard code once `import.meta` is supported in Expo
  // if (import.meta !== undefined && import.meta.env !== undefined) {
  if (import.meta.env !== undefined) {
    return import.meta.env.DEV
  }

  // @ts-expect-error Only exists in Expo / RN
  if (globalThis?.__DEV__ === true) {
    return true
  }

  return false
}

export const objectToString = (error: any): string => {
  const str = error?.toString()
  if (str !== '[object Object]') return str

  try {
    return JSON.stringify(error, null, 2)
  } catch (e: any) {
    console.log(error)

    return `Error while printing error: ${e}`
  }
}

export const tryAsFunctionAndNew = <TArg, TResult>(
  fnOrConstructor: ((arg: TArg) => TResult) | (new (arg: TArg) => TResult),
  arg: TArg,
): TResult => {
  try {
    // @ts-expect-error try out as constructor
    return new fnOrConstructor(arg)
  } catch (_e) {
    // @ts-expect-error try out as function
    return fnOrConstructor(arg)
  }
}

export const envTruish = (env: string | undefined) =>
  env !== undefined && env.toLowerCase() !== 'false' && env.toLowerCase() !== '0'

/**
 * Logs and throws for impossible states, pausing at a breakpoint in development.
 *
 * @param msg - The error message to log and pass to the error.
 * @param args - Arbitrary arguments to include in the log.
 *
 * @see {@link dieDebugger} for the Effect equivalent.
 */
export const shouldNeverHappen = (msg?: string, ...args: ReadonlyArray<unknown>): never => {
  console.error(msg, ...args)
  if (isDevEnv() === true) {
    // oxlint-disable-next-line eslint(no-debugger) -- intentional breakpoint during development
    debugger
  }

  throw new Error(`This should never happen: ${msg}`)
}
